function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } }

function _createClass(Constructor, protoProps, staticProps) { if (protoProps) _defineProperties(Constructor.prototype, protoProps); if (staticProps) _defineProperties(Constructor, staticProps); Object.defineProperty(Constructor, "prototype", { writable: false }); return Constructor; }

import { GLOBAL_RATE_LIMIT_CAPACITY_DEFAULT as hi, GLOBAL_RATE_LIMIT_REFILL_RATE_DEFAULT as li } from "../common/constants.js";

var Qt = /*#__PURE__*/function () {
  function Qt() {
    var t = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : 0;
    var i = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : [];
    var s = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : [];
    var h = arguments.length > 3 && arguments[3] !== undefined ? arguments[3] : [];
    var e = arguments.length > 4 && arguments[4] !== undefined ? arguments[4] : null;
    var l = arguments.length > 5 && arguments[5] !== undefined ? arguments[5] : null;
    var r = arguments.length > 6 && arguments[6] !== undefined ? arguments[6] : {
      enabled: !1
    };
    var a = arguments.length > 7 && arguments[7] !== undefined ? arguments[7] : {
      enabled: !1,
      refresh_rate_limit: void 0
    };
    var n = arguments.length > 8 && arguments[8] !== undefined ? arguments[8] : {
      enabled: !0,
      capacity: hi,
      refill_rate: li,
      endpoint_overrides: {}
    };
    var o = arguments.length > 9 && arguments[9] !== undefined ? arguments[9] : null;

    _classCallCheck(this, Qt);

    this.dl = t, this.Rl = i, this.Cl = s, this.El = h, this.yl = e, this.fl = l, this.vl = r, this.De = a, this.bl = n, this.banners = o, this.dl = t, this.Rl = i, this.Cl = s, this.El = h, this.yl = e, this.fl = l, this.vl = r, this.De = a, this.bl = n, this.banners = o;
  }

  _createClass(Qt, [{
    key: "bt",
    value: function bt() {
      return {
        s: "5.9.0",
        l: this.dl,
        e: this.Rl,
        a: this.Cl,
        p: this.El,
        m: this.yl,
        v: this.fl,
        c: this.vl,
        f: this.De,
        grl: this.bl,
        b: this.banners
      };
    }
  }], [{
    key: "Rn",
    value: function Rn(t) {
      var i = t.l;
      return "5.9.0" !== t.s && (i = 0), new Qt(i, t.e, t.a, t.p, t.m, t.v, t.c, t.f, t.grl, t.b);
    }
  }]);

  return Qt;
}();

export { Qt as default };